import { useState, useContext, useEffect } from 'react';
import { PaxContext } from '../../utils/context/checkoutContext';
import Image from 'next/image';

export const CurrencySwitcherToggle = () => {
  const { currency, updateCurrency }: any = useContext(PaxContext);

  // Get currency and updateCurrency from context
  const [selectedCurrency, setSelectedCurrency] = useState(currency); // Set the initial state based on context

  useEffect(() => {
    setSelectedCurrency(currency);
  }, [currency]);

  const handleCurrencyChange = (newCurrency: string) => {
    setSelectedCurrency(newCurrency); // Update the local state
    updateCurrency(newCurrency); // Update the context
  };

  return (
    <div className="flex items-center justify-between h-[40px] rounded-full border border-[#E0E0E0] bg-[#F7F8FB] p-[2px] shadow-sm">
      <button
        onClick={() => handleCurrencyChange('USD')}
        className={`flex items-center gap-1 px-3 h-8 rounded-full transition-all duration-300 ease-in-out text-[15px] font-semibold ${
          selectedCurrency === 'USD'
            ? 'bg-white shadow text-[#101010] font-bold'
            : 'bg-transparent text-[#677083]'
        }`}
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <Image
            src="/us-flag-icon.svg"
            alt="US Flag"
            width={20}
            height={20}
            className="rounded-full"
          />
        </span>
        USD
      </button>
      <button
        onClick={() => handleCurrencyChange('CAD')}
        className={`flex items-center gap-1 px-3 h-8 rounded-full transition-all duration-300 ease-in-out text-[15px] font-semibold ${
          selectedCurrency === 'CAD'
            ? 'bg-white shadow text-[#101010] font-bold'
            : 'bg-transparent text-[#677083]'
        }`}
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <Image
            src="/canada-flag-icon.svg"
            alt="Canada Flag"
            width={20}
            height={20}
            className="rounded-full"
          />
        </span>
        CAD
      </button>
    </div>
  );
};
